/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import { redirect, type Params } from 'react-router-dom';

import { Products } from '@fai/constants/domain-values';
import { getIsPlanInaccessible } from '@fai/friendli-suite/features/products/serverless-endpoints/plan';
import { getProductServerlessEndpointsPlan } from '@fai/friendli-suite/features/routes/loaders/apis/product/serverless-endpoints';
import Paths from '@fai/friendli-suite/features/routes/paths';

/**
 * redirects to best page for user's permissions and team's plans
 */
export const checkServerlessEndpointsAuthority = async ({
  params,
}: {
  params: Params<'teamId'>;
}) => {
  const teamId = params.teamId ?? '';
  const plan = await getProductServerlessEndpointsPlan({ teamId });
  const inaccessibility = getIsPlanInaccessible(plan);

  if (!inaccessibility) {
    return redirect(Paths.team(teamId).serverlessEndpoints.default);
  }

  if (plan === 'NONE_MEMBER' || plan === 'ACCESS_REQUIRED') {
    return redirect(`${Paths.team(teamId).suite}?contact=${Products.ServerlessEndpoints}`);
  }

  return redirect(Paths.team(teamId).suite);
};
